import styled from "styled-components";

export const SpanTextTitle = styled.span`
  color: #000;
  font-size: 14px;

  @media print {
    font-size: 9pt;
  }
`;

export const SpanTitleInvoice = styled.strong`
  font-size: 26px;
  font-weight: 300;
`;

export const TableScroll = styled.div`
  max-height: 440px;
  overflow-y: auto;
  margin-top: 8px;
    scrollbar-width: thin;
`;

export const SpanTitleQrCode = styled.strong`
  font-size: 26px;
  font-weight: 300;
  text-align: center;
  justify-content: center;
  margin-top: 5px;
`;

export const SpanTextInvoiceBold = styled.strong`
  font-size: 26px;
  font-weight: 600;
  padding-left: 1rem;
`;

export const FooterFixed = styled.div`
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 50px;

   a {
    margin-bottom: 0;
   }
`;

export const SmallTextInvoice = styled.small`
  font-size: 36px;
  padding-right: 1rem;
`;

export const BiggerTextInvoice = styled.strong`
  font-size: 4rem;
`;

export const SpanTextTitleBold = styled.span`
  color: #000;
  font-weight: bold;
  font-size: 14px;

  @media print {
    font-size: 8pt;
  }
`;

export const SpanTextTitleDataBold = styled.span`
  color: #707070;
  font-weight: bold;
  font-size: 13px;
  margin-left: 1%;

  @media print {
    margin-left: 0;
    color: #000;
    font-size: 7pt;
  }
`;

export const TextParagraph = styled.div`
  text-align: center;
  font-size: 32px;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 200px;

  @media print {
    font-size: 24pt;
  }
`;

export const SpanTextValueTitle = styled.span`
  color: #000;
  font-size: 12px;
  margin-left: 3%;
  width: 100%;

  @media print {
    font-size: 8pt;
    width: 350px;
    margin-left: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const SpanTextValuePayment = styled.span`
  color: #1feb52;
  font-size: 12px;
  font-weight: 600;
  width: 50px;

  @media print {
    font-size: 7pt;
    color: #000;
  }
`;
export const SpanTextValueTitlePayment = styled.span`
  color: #1feb52;
  font-size: 12px;
  margin-left: 3%;
  width: 100%;

  @media print {
    font-size: 8pt;
    width: 350px;
    margin-left: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #000;
  }
`;

export const SpanTextValue = styled.span`
  color: #000;
  font-size: 12px;
  font-weight: 600;
  width: 50px;

  @media print {
    font-size: 7pt;
  }
`;
export const SpanTextValueBold = styled.span`
  color: #000;
  font-size: 12px;
  font-weight: bold;

  @media print {
    font-size: 7pt;
  }
`;

export const TitleFaturaTextValue = styled.span`
  color: #000;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  width: 50%;

  @media print {
    font-size: 9pt;
  }
`;

export const DateFaturaTextValue = styled.span`
  color: #000;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  width: 50%;
  display: flex;
  justify-content: flex-end;

  @media print {
    font-size: 8pt;
  }
`;

export const TitleH1 = styled.span`
  text-align: center;
  font-size: 54px;
  font-weight: 600;
  position: relative;
`;

export const DescriptionH2 = styled.span`
  text-align: center;
  font-size: 13px;
  font-weight: 600;

  @media print {
    font-size: 9pt;
    color: #000;
  }
`;

export const SpanDescription = styled.strong`
  font-size: 26px;
  font-weight: 500;
  text-align: center;
`;

export const Dividers = styled.hr`
  border-top: 3px dashed #7c7c7c;
  width: 100%;
  height: 1px;

  @media print {
    border-top: 1px solid #000;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 34%;
  height: 55%;
  /* max-width: 500px; */
  max-height: 400px;
  padding: 15px;
  margin: 0px;
  background-color: #f5f5f5;
  /* position: absolute; */

  @media print {
    background: transparent !important;
    color: #000 !important;
    text-shadow: none !important;
    filter: none !important;
    -ms-filter: none !important;
  }
`;

export const Box = styled.div`
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background-color: #e7e7e7;
  border-width: 1px;
  border-color: 10px;
  margin-top: 10px;
  elevation: 10;
`;

export const QrCodePicture = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background-color: #e7e7e7;
  border-width: 1px;
  border-color: 10px;
  elevation: 10;
`;
